module.exports = __webpack_public_path__ + "static/img/shopeexpress.45f9c39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrier/shopeexpress.png
// module id = HE7n
// module chunks = 134